import * as stateManagement from '#packages/stateManagement';

export const {
  attachCandidateSel,
  selectedCompsSel,
  singleSelectedCompSel,
  isMultiselectSel,
} = stateManagement.stateMapperArgsSelectors.selectedCompsSels;
